//var level=0;
var idCount = 1;
var liHtml = "<li class='permissions-list-item' id='' tabindex='0'>" +
					"<span class=''></span>" + 
					"<div class='permission-item-cell'>" +
						"<span class='list-item-title'></span>" +
					"</div>" + 
					"<div class='list-radio-btn permission-item-cell'>" + 
						"<label class='radio radio-red'>" +
							"<input class='radio1' type='radio' name=''>" +
							"<span class='outer' tabindex='1'><span class='inner'></span></span>" +
						"</label>" +
					"</div>" +
					"<div class='list-radio-btn permission-item-cell'>" +
						"<label class='radio radio-orange'>" +
							"<input class='radio2' type='radio' name=''>" + 
							"<span class='outer' tabindex='1'><span class='inner'></span></span>" + 
						"</label>" +
					"</div>" +
					"<div class='list-radio-btn permission-item-cell'>" +
						"<label class='radio radio-green'>" + 
							"<input class='radio3' type='radio' name=''>" + 
							"<span class='outer' tabindex='1'><span class='inner'></span></span>" +
						"</label>" + 
					"</div>" +
					 "<div class='permission-item-cell permission-item-actions'></div>" +
					 "<ul class='permissions-list displayNone'></ul>" +
				"</li>"; 
				     
				
var liPopupHtml = "<li class='permissions-popup-list-item' tabindex='1' style='display: inline-block'>" +
					"<div class='popup-item-cell popup-item-title'></div>" +
					"<div class='popup-item-cell'>" +
						"<label class='radio radio-red'>" +
							"<input class='radio1' type='radio' name=''>" +
							"<span class='outer' tabindex='1'>" +
								"<span class='inner'></span>" +
							"</span>" +
						"</label>" +
					"</div>" +
					"<div class='popup-item-cell'>" +
						"<label class='radio radio-orange'>" +
							"<input class='radio2' type='radio' name=''> " +
							"<span class='outer' tabindex='1'>" +
								"<span class='inner'></span>" +
							"</span>" +
						"</label>" +
					"</div>" +
					"<div class='popup-item-cell licence-cell'>" +
						"<label class='radio radio-green-orange'>" +
							"<input class='radio4' type='radio' name=''> " +
							"<span class='outer' tabindex='1'>" +
								"<span class='inner'></span>" +
							"</span>" +
						"</label>" +
					"</div>" +
					"<div class='popup-item-cell'>" +
						"<label class='radio radio-green'>" +
							"<input class='radio3' type='radio' name=''>" +
							"<span class='outer' tabindex='1'>" +
								"<span class='inner'></span>" +
							"</span>" +
						"</label>" +
					"</div>" +
					"<div class='popup-item-cell'>" +
						"<div class='permissions-required-field' tabindex='1'>" +
							"<img src='"+baseUrl+"/images/asterix-gray.png' alt='required field icon'>" +
						"</div>" +
					"</div>" +
				"</li>";

 var buttons = "<table cellspacing='0' cellpadding='0' id='iconsListOnTop'>" +
	"<tbody>" +
		"<tr>" +
			"<td><img class='save-btn' src='" + baseUrl + "/images/clear.cache.gif' onClick='saveBtnChanges(this)' title='saveBtnTitle'>" +
			"</td>" +
			"<td><img class='undo-btn' src='" + baseUrl + "/images/clear.cache.gif' onClick='undoChanges(this)' title='undoBtnTitle'>" +
			"</td>" +
		"</tr>" +
	"</tbody>" +
"</table>";



// function create_permission_explorer_html(root, privTree, uniqueCod) {
 	// //if(permissionExplorerHTML == null) { 
 		// $.get("ng/views/permissions-explorer.html", function(data) {
			// //var uniqueCod = getNextDomID();
			// permissionExplorerHTML = data.replace("permissions-main","permissions-main " + uniqueCod);
		 	// $permissionExplorerDomElement = startDomHtml(uniqueCod,getUserLogin(privTree), permissionExplorerHTML, "80", 5, privTree, false);
			// PaintOneLevel(root, 1, 0,uniqueCod);
			// initPermissions(uniqueCod);
		// });
		// var currentButtons = buttons.replace("save-btn", "save-btn " + uniqueCod)
		// currentButtons = currentButtons.replace("undo-btn", "undo-btn " + uniqueCod)
		// setButtonsPanelHtml(currentButtons);
        // // $('#permissionExplorer').remove();
	// //} 
// }			

// function getUniqueCod(){
	// var cod = Date.now() + "";
	// cod = cod.substring(cod.length, cod.length-5);
	// return cod;
// }

function saveBtnChanges(e){
	var winID = $(e).prop('className').split(' ')[1];
	saveChanges(winID);
}

function undoChanges(e){
	var winID = $(e).prop('className').split(' ')[1];
	doUndo(winID);
}

function saveBtnChangesByWinId(winID){
	saveChanges(winID);
}

function undoChangesByWinId(winID){
	doUndo(winID);
}

// Adding Event Listener to the Copy button and showing dropdown list
	var activateCopyAndDeleteBtn = function() {
		$('.perm-copy-permissions-btn').on('click', function(e) {
			$(this).next().toggleClass('hidden-dropdown');
		});
		
		$('.perm-copy-users').on('click', function(e) {
			e.stopPropagation();
			var pathStr = changeToPathStr($(e.currentTarget).closest("li.permissions-list-item").children("ul.permissions-list").attr("data-id"));
			var winID = $(e.currentTarget).parents('.permissions-main').prop('className').split(' ')[1];
			$(e.currentTarget).parents('.perm-copy-dropdown').toggleClass('hidden-dropdown');
			openForm(winID, pathStr , 2); 
		});
		
		$('.perm-copy-clients').on('click', function(e) {
			e.stopPropagation();
			var pathStr = changeToPathStr($(e.currentTarget).closest("li.permissions-list-item").children("ul.permissions-list").attr("data-id"));
			var winID = $(e.currentTarget).parents('.permissions-main').prop('className').split(' ')[1];
			$(e.currentTarget).parents('.perm-copy-dropdown').toggleClass('hidden-dropdown');
			openForm(winID, pathStr , 3);
		});
	};

	
function col_logic_handler_callback(winID, pathStr, colLogic){
	$('.' + winID + ' .active-permission').children('.permission-item-actions').empty();
	var permBtn1 = $('<img>').addClass('permissions-btn perm-copy-permissions-btn');
	permBtn1.attr({ src:baseUrl+"/images/icon_copy.png", title:get_message_string(1280), alt:"copy icon", tabindex:"1" });

	var permDrop = $('<ul>').addClass('perm-copy-dropdown hidden-dropdown');
	var permDropItem1 = $('<li>').addClass('perm-copy-dropdown-item');
	var permDropItem2 = $('<li>').addClass('perm-copy-dropdown-item');
	var permDropLink1 = $('<a href="#" class="perm-copy-users">' + get_message_string(1284) + '</a>');//"משתמשים"
	var permDropLink2 = $('<a href="#" class="perm-copy-clients">' + get_message_string(1285) + '</a>');//"חברות"
	
	var	permBtn2 = $('<img>').addClass('permissions-btn perm-column-permissions-btn');
	permBtn2.attr({ src:baseUrl+"/images/icon_table.png", title:get_message_string(1281), alt:"columns permissions icon", tabindex:"1" });

	var permBtn3 = $('<img>').addClass('permissions-btn perm-notification-btn');
	permBtn3.attr({ src:baseUrl+"/images/icon_warning.png", title:get_message_string(1282), alt:"notifications icon", tabindex:"1" });
	
	var permImg4 = $('<img>').attr({ src:baseUrl+"/images/icon_approve_white.png", alt:"approve icon", tabindex:"1" });
	
	colLogicsArray[winID] = colLogic;
	
	//$colLogic = colLogic;
	if (getItemDeletePermissions(winID, pathStr) == false){
		permImg4 = $('<img>').attr({ src:baseUrl+"/images/icon_approve_blue.png", alt:"approve icon", tabindex:"1" }).addClass("allow-delete");
	}
	var permBtn4 = $('<span>' + get_message_string(1283) + '</span>').addClass('permission-del-btn').prepend(permImg4);
	
	// Binding created icons to the active row
	permDropItem1.append(permDropLink1);
	permDropItem2.append(permDropLink2);
	permDrop.append(permDropItem1, permDropItem2);

	// Binding created icons to the active row
	$('.' + winID + ' .active-permission').children('.permission-item-actions').append(permBtn1, permBtn2, permBtn3, permBtn4);
	permBtn1.after(permDrop);
	activateCopyAndDeleteBtn();
	
	showPermissionItems();
	setPermissionDeleting();
	showNotification();
}

function paintActionButtons(winID)
{
	$('.' + winID + ' .active-permission').children('.permission-item-actions').empty();
	var permBtn1 = $('<img>').addClass('permissions-btn perm-copy-permissions-btn');
	permBtn1.attr({ src:baseUrl+"/images/icon_copy.png", title:get_message_string(1280), alt:"copy icon", tabindex:"1" });
	if($('.' + winID + ' .active-permission').children('.circle-status-icon').length > 0)
	{
		permBtn1.css({opacity:0.3, cursor: 'default'});
	}

	var permDrop = $('<ul>').addClass('perm-copy-dropdown hidden-dropdown');
	var permDropItem1 = $('<li>').addClass('perm-copy-dropdown-item');
	var permDropItem2 = $('<li>').addClass('perm-copy-dropdown-item');
	var permDropLink1 = $('<a href="#" class="perm-copy-users">' + get_message_string(1284) + '</a>');//"משתמשים"
	var permDropLink2 = $('<a href="#" class="perm-copy-clients">' + get_message_string(1285) + '</a>');//"חברות"
	
	var	permBtn2 = $('<img>').addClass('permissions-btn perm-column-permissions-btn').css({opacity:0.3, cursor: 'default'});
	permBtn2.attr({ src:baseUrl+"/images/icon_table.png", alt:"columns permissions icon", tabindex:"1" });

	var permBtn3 = $('<img>').addClass('permissions-btn perm-notification-btn').css({opacity:0.3, cursor: 'default'});
	permBtn3.attr({ src:baseUrl+"/images/icon_warning.png", alt:"notifications icon", tabindex:"1" });
	
	var permImg4 = $('<img>').attr({ src:baseUrl+"/images/icon_approve_white.png", alt:"approve icon", tabindex:"1" });
	
	var permBtn4 = $('<span>' + get_message_string(1283) + '</span>').addClass('permission-del-btn').prepend(permImg4).css({opacity:0.3, cursor: 'default'});
	
	// Binding created icons to the active row
	permDropItem1.append(permDropLink1);
	permDropItem2.append(permDropLink2);
	permDrop.append(permDropItem1, permDropItem2);

	// Binding created icons to the active row
	$('.' + winID + ' .active-permission').children('.permission-item-actions').append(permBtn1, permBtn2, permBtn3, permBtn4);
	permBtn1.after(permDrop);
	if($('.' + winID + ' .active-permission').children('.circle-status-icon').length == 0)
	{
		activateCopyAndDeleteBtn();
	}
	
}

var privTreeHtml;

function priv_tree_handler_callback(privTree,pathStr)
{
	var uniqueCod = getNextDomID();	
	
	window.privRestriction = privTree.hasmdm === '0';
	
	$.get(baseUrl+"/ng/views/permissions-explorer.html", function(data) {
			//var uniqueCod = getNextDomID();
			//getUserLogin(uniqueCod)
			permissionExplorerHTML = data.replace("permissions-main","permissions-main " + uniqueCod);
		 	$permissionExplorerDomElement = startDomHtml(uniqueCod,getUserLogin(privTree), permissionExplorerHTML, "80", 5, privTree, false);
			
			var privTreeXML = getItemPermissions(uniqueCod, '[0]', 10);
			privTreeXML = '<?xml version="1.0" encoding="UTF-8"?>'+privTreeXML;
			privTreeXML = privTreeXML.replace(/>\s*/g, '>');  // Replace "> " with ">"
			privTreeXML = privTreeXML.replace(/\s*</g, '<');  // Replace "< " with "<"
			//privTreeXML = privTreeXML.replace(/\&/g, "and");
			$x = privTreeXML;
			try {
				xmlDoc = $.parseXML($x), $xml = $(xmlDoc);
			}
			catch(e) {
				console.log(e);
			}
			
			PaintOneLevel(xmlDoc.childNodes[0], 1, -1,uniqueCod);
			initPermissions(uniqueCod, pathStr);
			
			var currentButtons = buttons.replace("save-btn", "save-btn " + uniqueCod);
			currentButtons = currentButtons.replace("undo-btn", "undo-btn " + uniqueCod);
			currentButtons = currentButtons.replace("saveBtnTitle", get_message_string(1212));
			currentButtons = currentButtons.replace("undoBtnTitle", get_message_string(1283) + " (ctrl + Z) ");
			
			setButtonsPanelHtml(currentButtons, uniqueCod);
			privTreeHtml = currentButtons;
			if(document.getElementsByClassName("priv-tree")[0]){
				document.getElementsByClassName("priv-tree")[0].innerHTML = currentButtons;
			}
		});
	
	
	
	//create_permission_explorer_html(xmlDoc.children[0].getElementsByTagName("children")[0], privTree, uniqueCod); 
}

function PaintOneLevel(currentNode, num, id,uniqueCod)
{
	if (currentNode != undefined)
	{	       
		ulWindowParent = $("." + uniqueCod).find("ul[data-id='" + id + "']");
		// currentNode.children.forEach(function(value, index) { });
		
		$(currentNode.childNodes).each(function(index,item){
			ulWindowParent.append(liHtml);
			ulWindowParent.find("li:last").attr("data-level", num);//.attr("id", idCount)
			//$("ul[data-id='" + id + "'] li:last").attr("data-level", num);
			if(id == -1) {
				ulWindowParent.find("li:last ul.permissions-list").attr("data-id", index);
			}
			else{
				ulWindowParent.find("li:last ul.permissions-list").attr("data-id", id + "_" + index);
			}
			
			ulWindowParent.find("li:last .list-item-title").addClass("level" + num).text(item.getElementsByTagName("title")[0].textContent);
			//$("ul[data-id='" + id + "'] li:last .list-item-title").addClass("level" + num);
			idCount++;
			
			if(item.getElementsByTagName("type")[0].textContent == 0)
			{
				ulWindowParent.find("li:last .list-item-title").addClass("merk_item_title_R");
				ulWindowParent.find("li:last .list-radio-btn .radio2").attr('disabled', true);
				ulWindowParent.find("li:last .list-radio-btn .radio2").parent().addClass("radio-disabled");
			}
			else if(item.getElementsByTagName("type")[0].textContent  == 1)
			{
				ulWindowParent.find("li:last .list-item-title").addClass("merk_item_title_P");
				ulWindowParent.find("li:last .list-radio-btn .radio2").attr('disabled', true);
				ulWindowParent.find("li:last .list-radio-btn .radio2").parent().addClass("radio-disabled");
			}
			else if(item.getElementsByTagName("type")[0].textContent == 2)
			{
				ulWindowParent.find("li:last .list-item-title").addClass("merk_item_title_F");
				//$("ul[data-id='" + id + "'] li:last").append("<div class='permission-item-cell permission-item-actions'></div>");
			}
			else if(item.getElementsByTagName("type")[0].textContent == 3)
			{
				ulWindowParent.find("li:last .list-item-title").addClass("merk_item_title_W");
				ulWindowParent.find("li:last .list-radio-btn .radio2").attr('disabled', true);
				ulWindowParent.find("li:last .list-radio-btn .radio2").parent().addClass("radio-disabled");
			}
			else if(item.getElementsByTagName("type")[0].textContent == 4)
			{
				ulWindowParent.find("li:last .list-item-title").addClass("merk_item_title_D");
				ulWindowParent.find("li:last .list-radio-btn .radio2").attr('disabled', true);
				ulWindowParent.find("li:last .list-radio-btn .radio2").parent().addClass("radio-disabled");
			}
			else if(item.getElementsByTagName("type")[0].textContent == 5)
			{
				ulWindowParent.find("li:last .list-item-title").addClass("merk_item_title_M");
				
			}
			else if(item.getElementsByTagName("type")[0].textContent == 6)
			{
				ulWindowParent.find("li:last .list-item-title").addClass("merk_item_title_W");
			}
			else if(item.getElementsByTagName("type")[0].textContent == 7)
			{
				ulWindowParent.find("li:last .list-item-title").addClass("");
				ulWindowParent.find("li:last .list-radio-btn .radio2").attr('disabled', true);
				ulWindowParent.find("li:last .list-radio-btn .radio2").parent().addClass("radio-disabled");
			}
			else if(item.getElementsByTagName("type")[0].textContent == 8)
			{
				ulWindowParent.find("li:last .list-item-title").addClass("merk_item_title_T");
				ulWindowParent.find("li:last .list-radio-btn .radio2").attr('disabled', true);
				ulWindowParent.find("li:last .list-radio-btn .radio2").parent().addClass("radio-disabled");
			}
			
			// Aharon, 29/2/2016 vvv
			if (item.getElementsByTagName("blockRadio")[0].textContent == 2)
			{
				ulWindowParent.find("li:last .list-radio-btn .radio2").attr('disabled', true);
				ulWindowParent.find("li:last .list-radio-btn .radio2").parent().addClass("radio-disabled");
			}
			// Aharon, 29/2/2016 ^^^
			
			$numPriv = item.getElementsByTagName("priv")[0].textContent
			
			if($numPriv.charAt(0) == '2')
			{
				ulWindowParent.find("li:last .list-radio-btn .radio3").parent().addClass("partly-checked");
			}
			else if($numPriv.charAt(0) == '3')
			{
				ulWindowParent.find("li:last .list-radio-btn .radio3").attr('checked', 'checked');
			}
			
			if($numPriv.charAt(1) == '2')
			{
				ulWindowParent.find("li:last .list-radio-btn .radio2").parent().addClass("partly-checked");
			}
			else if($numPriv.charAt(1) == '3')
			{
				ulWindowParent.find("li:last .list-radio-btn .radio2").attr('checked', 'checked');
			}
			
			if($numPriv.charAt(2) == '2')
			{
				ulWindowParent.find("li:last .list-radio-btn .radio1").parent().addClass("partly-checked");
			}
			else if($numPriv.charAt(2) == '3')
			{
				ulWindowParent.find("li:last .list-radio-btn .radio1").attr('checked', 'checked');
			}
			
			if($numPriv.charAt(3) == '2')
			{
				ulWindowParent.find("li:last span:first").addClass("circle-status-icon");
			}
			
			// if($numPriv & parseInt('0001', 2) && $numPriv & parseInt('0010', 2) && $numPriv & parseInt('0100', 2))
			// {
				// ulWindowParent.find("li:last .list-radio-btn .radio1").parent().addClass("partly-checked");
				// ulWindowParent.find("li:last .list-radio-btn .radio2").parent().addClass("partly-checked");
				// ulWindowParent.find("li:last .list-radio-btn .radio3").parent().addClass("partly-checked");
				
			// }
			// else if($numPriv & parseInt('0001', 2) && $numPriv & parseInt('0010', 2))
			// {
				// ulWindowParent.find("li:last .list-radio-btn .radio1").parent().addClass("partly-checked");
				// ulWindowParent.find("li:last .list-radio-btn .radio2").parent().addClass("partly-checked");
				
			// }
			// else if($numPriv & parseInt('0001', 2) && $numPriv & parseInt('0100', 2))
			// {
				// ulWindowParent.find("li:last .list-radio-btn .radio1").parent().addClass("partly-checked");
				// ulWindowParent.find("li:last .list-radio-btn .radio3").parent().addClass("partly-checked");
			// }
			// else if($numPriv & parseInt('0010', 2) && $numPriv & parseInt('0100', 2))
			// {
				// ulWindowParent.find("li:last .list-radio-btn .radio2").parent().addClass("partly-checked");
				// ulWindowParent.find("li:last .list-radio-btn .radio3").parent().addClass("partly-checked");
			// }
			// else if($numPriv & parseInt('0001', 2))
			// {
				// ulWindowParent.find("li:last .list-radio-btn .radio1").attr('checked', 'checked');
			// }
			// else if($numPriv & parseInt('0010', 2))
			// {
				// ulWindowParent.find("li:last .list-radio-btn .radio2").attr('checked', 'checked');
			// }
			// else if($numPriv & parseInt('0100', 2))
			// {
				// ulWindowParent.find("li:last .list-radio-btn .radio3").attr('checked', 'checked');
			// }
			
			// if($numPriv & parseInt('10000', 2))
			// {
				 // ulWindowParent.find("li:last span:first").addClass("circle-status-icon");
			// }
			
			
			// if(item.getElementsByTagName("priv")[0].textContent == 0)
			// {
				// $("ul[data-id='" + id + "'] li:last .list-radio-btn .radio3").attr('checked', 'checked');
				// // $("ul[data-id='" + id + "'] li:last span:first").addClass("circle-status-icon");
			// }
			// else if(item.getElementsByTagName("priv")[0].textContent  == 1)
			// {
				// $("ul[data-id='" + id + "'] li:last .list-radio-btn .radio2").attr('checked', 'checked');
			// }
			// else if(item.getElementsByTagName("priv")[0].textContent == 2)
			// {
				// $("ul[data-id='" + id + "'] li:last .list-radio-btn .radio3").attr('checked', 'checked');
			// }
			// else if(item.getElementsByTagName("priv")[0].textContent == 3)
			// {
				// $("ul[data-id='" + id + "'] li:last .list-radio-btn .radio1").attr('checked', 'checked');
			// }
			// else if(item.getElementsByTagName("priv")[0].textContent  == 4)
			// {
				// $("ul[data-id='" + id + "'] li:last .list-radio-btn .radio2").attr('checked', 'checked');
			// }
			// else if(item.getElementsByTagName("priv")[0].textContent == 5)
			// {
				// $("ul[data-id='" + id + "'] li:last .list-radio-btn .radio3").attr('checked', 'checked');
			// }
			// else if(item.getElementsByTagName("priv")[0].textContent == 6)
			// {
				// $("ul[data-id='" + id + "'] li:last .list-radio-btn .radio1").attr('checked', 'checked');
				// $("ul[data-id='" + id + "'] li:last .list-radio-btn .radio3").attr('checked', 'checked');
				// // $("ul[data-id='" + id + "'] li:last .list-radio-btn #radio3").attr('checked', 'checked');
			// }
			// else if(item.getElementsByTagName("priv")[0].textContent  == 7)
			// {
				// $("ul[data-id='" + id + "'] li:last .list-radio-btn .radio3").attr('checked', 'checked');
			// }
			// else if(item.getElementsByTagName("priv")[0].textContent == 8)
			// { 
				// $("ul[data-id='" + id + "'] li:last .list-radio-btn .radio2").attr('checked', 'checked');
				// $("ul[data-id='" + id + "'] li:last .list-radio-btn .radio1").attr('checked', 'checked');
			// } 
			// else if(item.getElementsByTagName("priv")[0].textContent == 9)  
			// {
				// $("ul[data-id='" + id + "'] li:last .list-radio-btn .radio2").attr('checked', 'checked');
				// $("ul[data-id='" + id + "'] li:last .list-radio-btn .radio3").attr('checked', 'checked');
			// }
			// else if(item.getElementsByTagName("priv")[0].textContent == 10) 
			// {
				// $("ul[data-id='" + id + "'] li:last .list-radio-btn .radio3").attr('checked', 'checked');
				// // $("ul[data-id='" + id + "'] li:last .list-radio-btn #radio2").attr('checked', 'checked');
				// // $("ul[data-id='" + id + "'] li:last .list-radio-btn #radio3").attr('checked', 'checked');
			// } 
			
			
			if (item.getElementsByTagName("children").length > 0)
			{
				ulWindowParent.find("li:last").addClass("list_item_M");
				ulWindowParent.find("li:last .list-item-title").append("<i class='category-triangle'></i>");
				
				//PaintOneLevel(item.getElementsByTagName("children")[0], num + 1, id ,uniqueCod)
				//MakeNodeToHtml(item.getElementsByTagName("children")[0], num + 1, id * Math.pow(10, num) + index);
			}
			else{
				ulWindowParent.find("li:last .list-radio-btn input:radio").attr("name", "radiogroup" + uniqueCod + "_" + id + "_" + index);
			}
		})
	}
}

function changeToPathStr(dataId){
	// var pathStrObject = dataId.split("_");
	// pathStr = "[";
	
	// $(pathStrObject).each(function(index,item){
		// pathStr += item + " ";
	// });
	// pathStr += "]";

	pathStr = "[" + dataId.replace(/\_/g, " ") + " ]";
	
	return pathStr;
}

function xml_update(winID, nodeXml){
	nodeXml = '<?xml version="1.0" encoding="UTF-8"?>'+nodeXml;
	nodeXml = nodeXml.replace(/>\s*/g, '>');  // Replace "> " with ">"
	nodeXml = nodeXml.replace(/\s*</g, '<');  // Replace "< " with "<"
	try{
		xmlDoc = $.parseXML(nodeXml), $xml = $(xmlDoc);
	}
	catch(e)
	{
		console.log(e);
	}
	
		$(xmlDoc.childNodes[0].childNodes).each(function(index,item){
			var pathStr = item.getElementsByTagName("node")[0].textContent;
			var dataId = pathStr.replace("[", "").replace(" ]", "").replace("]", "").replace(/\ /g, "_");
			currentLi =  $(".permissions-main." + winID).find("ul[data-id='" + dataId + "']").parent("li");
			
			if (currentLi.length != 0) {
				 
				currentLi.find("> .list-radio-btn >> input:checked").each(function(){
					$(this).prop('checked', false);
				 });
				 
				 currentLi.find("> .list-radio-btn > .radio").removeClass("partly-checked");
				 currentLi.children("span:first").removeClass("circle-status-icon");
				 
				$numPriv = item.getElementsByTagName("privCode")[0].textContent;
				
				if($numPriv.charAt(0) == '2')
				{
					currentLi.find("> .list-radio-btn >> .radio3").parent().addClass("partly-checked");
				}
				else if($numPriv.charAt(0) == '3')
				{
					currentLi.find("> .list-radio-btn >> .radio3").prop('checked', true);
				}
				
				if($numPriv.charAt(1) == '2')
				{
					currentLi.find("> .list-radio-btn >> .radio2").parent().addClass("partly-checked");
				}
				else if($numPriv.charAt(1) == '3')
				{
					currentLi.find("> .list-radio-btn >> .radio2").prop('checked', true);
				}
				
				if($numPriv.charAt(2) == '2')
				{
					currentLi.find("> .list-radio-btn >> .radio1").parent().addClass("partly-checked");
				}
				else if($numPriv.charAt(2) == '3')
				{
					currentLi.find("> .list-radio-btn >> .radio1").prop('checked', true);
				}
				
				if($numPriv.charAt(3) == '2')
				{
					 currentLi.children("span:first").addClass("circle-status-icon");
				}
				
				
				// if($numPriv & parseInt('0001', 2) && $numPriv & parseInt('0010', 2) && $numPriv & parseInt('0100', 2))
				// {
					// currentLi.find("> .list-radio-btn >> .radio1").parent().addClass("partly-checked");
					// currentLi.find("> .list-radio-btn >> .radio2").parent().addClass("partly-checked");
					// currentLi.find("> .list-radio-btn >> .radio3").parent().addClass("partly-checked");
				// }
				// else if($numPriv & parseInt('0001', 2) && $numPriv & parseInt('0010', 2))
				// {
					// currentLi.find("> .list-radio-btn >> .radio1").parent().addClass("partly-checked");
					// currentLi.find("> .list-radio-btn >> .radio2").parent().addClass("partly-checked");
				// }
				// else if($numPriv & parseInt('0001', 2) && $numPriv & parseInt('0100', 2))
				// {
					// currentLi.find("> .list-radio-btn >> .radio1").parent().addClass("partly-checked");
					// currentLi.find("> .list-radio-btn >> .radio3").parent().addClass("partly-checked");
				// }
				// else if($numPriv & parseInt('0010', 2) && $numPriv & parseInt('0100', 2))
				// {
					// currentLi.find("> .list-radio-btn >> .radio2").parent().addClass("partly-checked");
					// currentLi.find("> .list-radio-btn >> .radio3").parent().addClass("partly-checked");
				// }
				// else if($numPriv & parseInt('0001', 2))
				// {
					// currentLi.find("> .list-radio-btn >> .radio1").prop('checked', true);
					// //currentLi.children(".list-radio-btn .radio1").attr('checked', 'checked');
				// }
				// else if($numPriv & parseInt('0010', 2))
				// {
					// currentLi.find("> .list-radio-btn >> .radio2").prop('checked', true);
					// //currentLi.children(".list-radio-btn .radio2").attr('checked', 'checked');
				// }
				// else if($numPriv & parseInt('0100', 2))
				// {
					// currentLi.find("> .list-radio-btn >> .radio3").prop('checked', true);
				// //	currentLi.children(".list-radio-btn .radio3").attr('checked', 'checked');
				// }
				
				// if($numPriv & parseInt('10000', 2))
				// {
					 // currentLi.children("span:first").addClass("circle-status-icon");
				// }
			}
			
		});

}

function getChilds(liNode,parentCod){
	var winID = liNode.parents('.permissions-main').prop('className').split(' ')[1];
	 var privTreeXML = getItemPermissions(winID, changeToPathStr(liNode.children("ul.permissions-list").attr("data-id")), 2);
	 privTreeXML = '<?xml version="1.0" encoding="UTF-8"?>'+privTreeXML;
	 privTreeXML = privTreeXML.replace(/>\s*/g, '>');  // Replace "> " with ">"
	 privTreeXML = privTreeXML.replace(/\s*</g, '<');  // Replace "< " with "<"
	 //privTreeXML = privTreeXML.replace(/\&/g, "and");
	 $x = privTreeXML;
	 try{
		xmlDoc = $.parseXML($x), $xml = $(xmlDoc);
	 }
	 catch(e)
	 {
		console.log(e);
	 }
	 
	 var level = parseInt(liNode.attr("data-level"), 10) + 1;
	 
	 PaintOneLevel(xmlDoc.childNodes[0].getElementsByTagName("children")[0], level, liNode.children("ul.permissions-list").attr("data-id"),parentCod)
}

var PrivTreeShow = null;
var colLogicsArray = new Array();
var $targetItem,
	$permissionItems,
	$popupItems,
	$permisionRadioBtn,
	$permissionItemsToEvent, 
	$permissionItemsToNavigate,
	$colLogic,
	$permissionExplorerDomElement;

	// Bring and show all current permission items
	var showPermissionItems = function() {

		// Permissions table button click or Enter keydown Event listener
		$('.perm-column-permissions-btn').click( function(e) {
			if (e.type === 'click' || e.keyCode === 13) {
			
				//e.stopPropagation();
				$popupItems.off('click keydown', activatePermissionItem);
				
				var windowParent =  $(e.currentTarget).parents('.permissions-main');
				var codID = windowParent.prop('className').split(' ')[1];
				if (!windowParent.find(".perm-copy-dropdown").hasClass("hidden-dropdown")){
					windowParent.find(".perm-copy-dropdown").toggleClass('hidden-dropdown');
				}
				// 1. Bring all child items from the server
				// 2. Append them to the popup window
				// 3. Show popup window
				if(colLogicsArray[codID] != null)
				{
					var columns = getColumnLogicXml(colLogicsArray[codID]);
					 columns = '<?xml version="1.0" encoding="UTF-8"?>'+columns;
					 columns = columns.replace(/>\s*/g, '>');  // Replace "> " with ">"
					 columns = columns.replace(/\s*</g, '<');  // Replace "< " with "<"
					$x = columns;
					try{
					xmlDoc = $.parseXML($x), $xml = $(xmlDoc);
					}
					catch(e)
					{
					console.log(e);
					}
					
					var parentList = windowParent.find(".permissions-popup-list");//.prop('className').split(' ')[1];
					
					parentList.find("li:not(:first)").remove();
					
					$(xmlDoc.childNodes[0].childNodes).each(function(index,item){
						
						parentList.append(liPopupHtml);
						parentList.find("li:last .popup-item-title").text(item.getElementsByTagName("title")[0].textContent);
						parentList.find("li:last .popup-item-cell input:radio").attr("name", "radiogroupPopup" + codID + "_" + index);
						parentList.find("li:last").attr("data-id", index);
						
						if(item.getElementsByTagName("type")[0].textContent == 0)
						{
							parentList.find("li:last .popup-item-cell .radio2").attr('checked', 'checked');
						}
						else if(item.getElementsByTagName("type")[0].textContent  == 1)
						{
							parentList.find("li:last .popup-item-cell .radio3").attr('checked', 'checked');
						}
						else if(item.getElementsByTagName("type")[0].textContent == 6)
						{
							parentList.find("li:last .popup-item-cell .radio4").attr('checked', 'checked');
						}
						else if(item.getElementsByTagName("type")[0].textContent == 2)
						{
							parentList.find("li:last .popup-item-cell .radio1").attr('checked', 'checked');
						}
						else if(item.getElementsByTagName("type")[0].textContent == 5)
						{
							parentList.find("li:last .popup-item-cell .radio3").attr('checked', 'checked');
							parentList.find("li:last .popup-item-cell .permissions-required-field img").attr('src', baseUrl+'/images/asterix-red.png');
							parentList.find("li:last .popup-item-cell .permissions-required-field").addClass('permissions-required');
						}
						
						if(item.getElementsByTagName("readonly")[0].textContent == "true")
						{
							parentList.find("li:last .popup-item-cell .radio3").attr('disabled', true);
							parentList.find("li:last .popup-item-cell .radio3").parent().addClass("radio-disabled");
							parentList.find("li:last .popup-item-cell .radio4").attr('disabled', true);
							parentList.find("li:last .popup-item-cell .radio4").parent().addClass("radio-disabled");
							parentList.find('li:last .popup-item-cell .permissions-required-field').css("cursor", "default");
						}
						else
						{
							// Set the field to be required
							parentList.find('li:last .popup-item-cell .permissions-required-field').click(function(e) {
								if (e.type === 'click' || e.keyCode === 13) {
									setRequiredField(e);	
								}
							});
						}
			
					})
				}

				// Adding dynamic height to the popup permissions
				$('.permissions-popup-list').css('height', (24 * $('.permissions-popup-list-item').length) + 4 + "px");
				if ($('.permissions-popup-list-item').length <= 10) {
					$('.permissions-popup-list').css('margin', "10px 20px 20px");
				} else {
					$('.permissions-popup-list').css('margin', "10px 11px 20px");
				}

			
				windowParent.find(".permissionsPopupTitle").text($(e.currentTarget).closest(".permissions-list-item").find(">> .list-item-title").text() + " - " + get_message_string(1287)); 
				windowParent.find('.permissionsPopup').removeClass('displayNone').focus();		
				
				$popupItems = $('.permissions-popup-list-item');
				$popupItems.on('click keydown', activatePermissionItem);
				
				
				
				$(".permissions-popup-list-item input:radio").on('click keydown', setToItemColumnsPermissions);
				$('.permissions-required-field').on('click keydown',setToItemColumnsPermissions);
				//$(".permissions-popup-list-item .popup-item-cell :not(.popup-item-title)").on('click keydown', setToItemColumnsPermissions);
			
				// Activate first permission row on popup
				windowParent.find('.permissions-popup-list-item:nth-child(2)').focus().addClass('active-permission');
				
				if (window.privRestriction) {
					parentList.find(".licence-cell").hide();
				}
				
			}
		});
	};


	// Allow or disable deleting records
	var setPermissionDeleting = function() {
		$('.permission-del-btn').click( function(e) {
			e.stopPropagation();
			$targetItem = $(e.currentTarget);
			var winID = $targetItem.parents(".permissions-main").prop('className').split(' ')[1];
			var pathStr = changeToPathStr($targetItem.closest("li").children("ul.permissions-list").attr("data-id"));
			
			if (!$targetItem.find('img').hasClass('allow-delete')) {
				$targetItem.find('img').addClass('allow-delete');
				$targetItem.find('img').attr('src', baseUrl+'/images/icon_approve_blue.png');
				setItemDeletePermissions(winID, pathStr, true);
			} 
			else {
				$targetItem.find('img').removeClass('allow-delete');
				$targetItem.find('img').attr('src', baseUrl+'/images/icon_approve_white.png');
				setItemDeletePermissions(winID, pathStr, false);
			}
		});
	};

	var showNotification = function() {
		$('.perm-notification-btn').click( function(e) {
			var pathStr = changeToPathStr($(e.currentTarget).closest("li.permissions-list-item").children("ul.permissions-list").attr("data-id"));
			var winID = $(e.currentTarget).parents('.permissions-main').prop('className').split(' ')[1];
			openForm(winID, pathStr , 1);
		});
	};

	var activateButtons = function() {
		var parentWindow = $targetItem.parents(".permissions-main")
		parentWindow.find('.permission-item-actions').empty();
		
		if ($targetItem.find(">> .merk_item_title_F").length > 0)
		{
			getItemColumnsPermissions(parentWindow.prop('className').split(' ')[1], changeToPathStr($targetItem.children("ul.permissions-list").attr("data-id")));
		}
		else
		{
			paintActionButtons(parentWindow.prop('className').split(' ')[1])
		}
		//addPermissionButtons();
		// showPermissionItems();
		// setPermissionDeleting();
	};


	var activatePermission = function(e) {
		$targetItem = $(e.currentTarget).closest("li.permissions-list-item");

		// // Keyboard keydown events
		// if (e.type === 'keydown') {
			// var $curID = $(e.target).attr('id'),
				// $nextID = parseInt($curID) + 1,
				// $prevID = parseInt($curID) - 1;

			// // Arrow down event listener
			// if (e.keyCode === 40) {
				// $nextItem = $('#' + $nextID);

				// $permissionItems.removeClass('active-permission');	
				// $nextItem.focus().addClass('active-permission');
				
				// activateButtons(e);

				// if ($nextItem.parent().hasClass('displayNone')) {
					// $nextItem.parent().removeClass('displayNone');
				// } 

			// // Arrow up event listener
			// } else if (e.keyCode === 38) {
				// var $prevItem = $('#' + $prevID);

				// $permissionItems.removeClass('active-permission');	
				// $prevItem.focus().addClass('active-permission');

				// activateButtons(e);

				// if ($prevItem.parent().hasClass('displayNone')) {
					// $prevItem.removeClass('displayNone');
				// } 

			// // Enter on radio button
			// } else if (e.keyCode === 13 && $(e.target).hasClass('outer')) {
				// $(e.target).prev().prop('checked', true);

			// // Arrow left or "Enter" event listener
			// } else if (e.keyCode === 37 || (e.keyCode === 13)) {
				// if ($targetItem.next().prop('tagName') == 'UL') {
					// $targetItem.next().removeClass('displayNone');
					// $targetItem.find('i').addClass('opened-category');
				// }

			// // Arrow right event listener
			// } else if (e.keyCode === 39) {
				// if ($targetItem.next().prop('tagName') == 'UL') {
					// $targetItem.next().addClass('displayNone');
					// $targetItem.find('i').removeClass('opened-category');
				// }
			// }
		// } 


		// If the row type is submenu (M) open it and show children
		if (e.type === 'click' && $targetItem.hasClass('list_item_M')) {
			if($targetItem.children("ul.permissions-list").children().length == 0){
				var parentCod = $(this).parents('.permissions-main').prop('className').split(' ')[1];
				getChilds($targetItem,parentCod);
				
				$permissionItemsToEvent.off('click', activatePermission);
				//$permissionItemsToNavigate.off('keydown', navigateLiEvents);
				$popupItems.off('click', activatePermissionItem);
				$permisionRadioBtn.off('click',permisionRadioBtnClick);
				$permisionRadioBtnParents.off('mouseup',unCheckedBrothers);
			
				//$permissionItemsToNavigate =  $('.permissions-list-item');
				$permissionItemsToEvent =  $('.permissions-list-item .list-item-title');//.children().not('.list-radio-btn').parent();
				$popupItems = $('.permissions-popup-list-item');
				$permisionRadioBtn = $('.list-radio-btn.permission-item-cell input:radio');
				$permisionRadioBtnParents = $('.list_item_M .list-radio-btn.permission-item-cell');
				$permissionItems =  $('.permissions-list-item');
				
				$permissionItemsToEvent.on('click', activatePermission);
				//$permissionItemsToNavigate.on('keydown', navigateLiEvents);
				$popupItems.on('click', activatePermissionItem);
				$permisionRadioBtn.on('click',permisionRadioBtnClick);
				$permisionRadioBtnParents.on('mouseup',unCheckedBrothers);
			}
			//$permissionItems.removeClass('active-permission');
			$targetItem.parents(".permissions-main").find('.active-permission').removeClass('active-permission');
			$targetItem.addClass('active-permission');
			activateButtons();

			if ($targetItem.children("ul.permissions-list").hasClass('displayNone')) {
				// Adding rotate animation to category arrow
				$targetItem.find('>> .list-item-title > i').addClass('opened-category');

				// Showing subcategory items 
				$targetItem.children("ul.permissions-list").removeClass('displayNone');
			} 
			else {
				$targetItem.find('.list-item-title i').removeClass('opened-category');

				// Hiding subcategory items 
				$targetItem.find("ul.permissions-list").addClass('displayNone');
			}
		} 
		else if (e.type === 'keydown' && $targetItem.hasClass('list_item_M')) {
			// console.log('$targetItem', $targetItem.next().get(0));

			if ($targetItem.next('ul').hasClass('displayNone')) {
				// Adding rotate animation to category arrow
				$targetItem.find('>> .list-item-title > i').addClass('opened-category');

				// Showing subcategory items 
				$targetItem.next('ul').removeClass('displayNone');
			}	
		} 
		else {

			// If the row doesn't have class 'active-permission' make it active
			if (!$targetItem.hasClass('active-permission')) {

				// Adding backgound to active row om mouse click
				if (e.type === 'click') {
					$targetItem.parents(".permissions-main").find('.active-permission').removeClass('active-permission');
					$targetItem.addClass('active-permission');			
				}

				// Remove action buttons from previous active item and add to the new one
				activateButtons();
			}
		}
	};	
	
	// Activating Popup permissions and it's buttons
	var activatePermissionItem = function(e) {
		$targetItem = $(e.currentTarget);
		//e.preventDefault();
		e.stopPropagation();
		
		var activeLi = $targetItem.parents(".permissions-main").find('.permissions-popup-list .active-permission');
		
		// Arrow up - activate previous row
		if (e.keyCode === 38) {
			activeLi.removeClass('active-permission');
			$targetItem.prev('li').focus().addClass('active-permission');

		// Arrow down - activate next row
		} else if (e.keyCode === 40) {
			activeLi.removeClass('active-permission');
			$targetItem.next('li').focus().addClass('active-permission');

		// Activating radio buttons from the keyboard
		} else if (e.keyCode === 13 && $(e.target).hasClass('outer')) {
			$(e.target).prev().prop('checked', true);

		// Close Permissions Popup on "Esc" keydown
		} else if (e.keyCode === 27) {
			$('.permissionsPopup').addClass('displayNone');
			$activeLi.removeClass('active-permission');

		// Activating row on mouse click and on "Tab" keydown
		} else {
			// Adding backgound to active row
			activeLi.removeClass('active-permission');
			$targetItem.addClass('active-permission');
		}
		
		if($targetItem.find(".permissions-required-field").hasClass('permissions-required') && !$targetItem.find(".radio3").prop("checked")) {
			$targetItem.find(".permissions-required-field").removeClass('permissions-required');
			$targetItem.find(".permissions-required-field img").attr('src', baseUrl+'/images/asterix-gray.png');
			//$targetItemReq.parents("li").find(".popup-item-cell .radio3").prop( "checked", false );
		}
		
	};

	var setToItemColumnsPermissions = function(e){
		//e.preventDefault();
		//e.stopPropagation();
		var winID = $(e.currentTarget).parents('.permissions-main').prop('className').split(' ')[1];
		var targetItemPer = $(e.currentTarget).closest("li.permissions-popup-list-item");
		var value = 5;
		if (targetItemPer.find(".popup-item-cell .radio2").prop('checked')) {
			value = 0;
		}
		else if(targetItemPer.find(".popup-item-cell .radio3").prop('checked') && !targetItemPer.find(".permissions-required-field").hasClass("permissions-required") ) {
			value = 1;
		}
		else if(targetItemPer.find(".popup-item-cell .radio1").prop('checked')){
			value = 2;
		}
		else if(targetItemPer.find(".popup-item-cell .radio4").prop('checked')){
			value = 6;
		}
		setItemColumnsPermissions(colLogicsArray[winID], targetItemPer.attr("data-id") , value);
	}
	
	var setRequiredField = function(e) {
		$targetItemReq = $(e.currentTarget);

		if (!$targetItemReq.hasClass('permissions-required')) {
			$targetItemReq.addClass('permissions-required');
			$targetItemReq.find('img').attr('src', baseUrl+'/images/asterix-red.png');
			$targetItemReq.parents("li").find(".popup-item-cell input:checked").prop( "checked", false );
			$targetItemReq.parents("li").find(".popup-item-cell .radio3").prop( "checked", true );
		} else {
			$targetItemReq.removeClass('permissions-required');
			$targetItemReq.find('img').attr('src', baseUrl+'/images/asterix-gray.png');
			//$targetItemReq.parents("li").find(".popup-item-cell .radio3").prop( "checked", false );
		}
	};

	// var permisionRadioBtnClick = function(e) {
		// $targetItem = $(e.currentTarget);
		// //e.preventDefault();
		// //e.stopPropagation();
		
		// var typePer = 0;
		// // $radioButtons = $targetItem.parents("li").children(".list-radio-btn").find("input:checked");
		
		// // $radioButtons.each(function(index,item){
			// // if($(item).hasClass("radio3")){
				// // typePer = typePer | parseInt('0100', 2)
			// // }
			// // else if($(item).hasClass("radio2")){
				// // typePer = typePer | parseInt('0010', 2)
			// // }
			// // else if($(item).hasClass("radio1")){
				// // typePer = typePer | parseInt('0001', 2)
			// // }
		// // })
		
		// // if( $targetItem.parents("li").children("span:first").hasClass("circle-status-icon")){
			// // typePer = typePer | parseInt('10000', 2);
		// // }
	
		// $brothers = $targetItem.parents( ".list-radio-btn" ).siblings( ".list-radio-btn" );
		// $len = $brothers.find("input:checked").length;
		// $targetItemIsChecked = $targetItem.find("input").is(':checked');
		// $targetItemClass = $targetItem.attr("class");
		// // if ($targetItemIsChecked)
		// // {
			// //$targetItem.find("input").prop('checked', true)
		// //	$len = $targetItem.siblings( ".list-radio-btn" ).find("input:checked").length;
			 
			  // if( $targetItemClass == "radio3" && $len == 0)
			  // {
				 // typePer = 2;
			  // }
			  // else if( $targetItemClass == "radio2" && $len == 0)
			  // {
				 // typePer = 1;
			  // }
			  // else if( $targetItemClass == "radio1" && $len == 0)
			  // {
				 // typePer = 3;
			  // }
			  // else if( ($targetItemClass == "radio1" || $targetItemClass == "radio3" 
						 // && $len == 1 && ($brothers[0].find("input").attr("id") == "radio3" || 
						 // $brothers[0].find("input").attr("id") == "radio1")))
			  // {
				 // typePer = 6;
			  // }
			  // else if( ($targetItemClass == "radio2" ||$targetItemClass == "radio3" 
						 // && $len == 1 && ($brothers[0].find("input").attr("id") == "radio3" || 
						 // $brothers[0].find("input").attr("id") == "radio2")))
			  // {
				 // typePer = 9;
			  // }
			  // else if( ($targetItemClass == "radio1" || $targetItemClass == "radio2" 
						 // && $len == 1 && ($brothers[0].find("input").attr("id") == "radio1" || 
						 // $brothers[0].find("input").attr("id") == "radio2")))
			  // {
				 // typePer = 8;
			  // }
			  // else if( $targetItemClass == "radio3" && $len == 2)
			  // {
				 // typePer = 10;
			  // }
		// // }
		// // else if ($len == 2 && $targetItemIsChecked)
		// // {
			// // // $targetItem.find("input").attr('checked', 'checked');
			 
			 // // $brothers.each(function(){
				// // $(this).find("input").prop('checked', false)
			 // // });
			 
			  // // if( $targetItem.find("input").attr("id") == "radio3")
			  // // {
				 // // typePer = 2;
			  // // }
			  // // else if( $targetItem.find("input").attr("id") == "radio2")
			  // // {
				 // // typePer = 1;
			  // // }
			  // // else if( $targetItem.find("input").attr("id") == "radio1")
			  // // {
				 // // typePer = 3;
			  // // }
		// // }
		// //else if($targetItem.find("input:checked").length == 0 
		
		 // // var pathStrObject = $targetItem.parent().next().attr("data-id").split("_");
		 // // pathStr = "[";
		
		 // // $(pathStrObject).each(function(index,item){
			 // // pathStr += item + " ";
		 // // });
		 // // pathStr += "]";
		
		// setItemPermissions($targetItem.parents('.permissions-main').prop('className').split(' ')[1], changeToPathStr($targetItem.closest("li").children("ul.permissions-list").attr("data-id")), typePer);
		// // $targetItem.parents("li").next().empty();
		// // $targetItem.parents("li").next().addClass("displaynone");
		 // //$targetItem.parents("li").find(".list-item-title i").removeClass("opened-category");
		// // saveChanges(PrivTreeShow);
	// };
	
	var permisionRadioBtnClick = function(e) {
		$targetItem = $(e.currentTarget);
		var typePer = 0;
		$targetItemClass = $targetItem.attr("class");
		if( $targetItemClass == "radio3")
		{
			typePer = 2;
		}
		else if( $targetItemClass == "radio2")
		{
			typePer = 1;
		}
		else if( $targetItemClass == "radio1")
		{
			typePer = 3;
		}
		else if( $targetItemClass == "radio4")
		{
			typePer = 6;
		}
		
		setItemPermissions($targetItem.parents('.permissions-main').prop('className').split(' ')[1], changeToPathStr($targetItem.closest("li").children("ul.permissions-list").attr("data-id")), typePer);
	};

	
	var unCheckedBrothers = function(e) {
		$targetItem = $(e.currentTarget);
	
		$brothers = $targetItem.siblings( ".list-radio-btn" );
		$len = $brothers.find("input:checked").length;
		
		if($len == 2 && $targetItem.find("input").is(':checked')){
			$brothers.each(function(){
				$(this).find("input").prop('checked', false);
			 });
		 }
	};
	
	// function navigateLiEvents(e){
	// e.preventDefault();
	// e.stopPropagation();
		// $targetItem = $(e.currentTarget).parents('.permissions-main').find(".active-permission");
		// // Arrow down event listener
		// if (e.keyCode === 40) {
			// _keyDownEvent(e);
		// }
		// // Arrow up event listener
		// else if (e.keyCode === 38) {
			// _keyUpEvent(e);
		// }
		// // Arrow left or "Enter" event listener
	    // else if (e.keyCode === 37) {
			// _keyLeftEvent(e); 
		// }
		// // Arrow right event listener
		// else if (e.keyCode === 39) {
			// _keyRightEvent(e);
		 // }
		 // // if($(".active-permission").offset().top > $(window).height())
		 // // {
			// // $("div.permissions-main").scrollTop($(".active-permission").offset().top + $(window).height());
		// // }
		// // else if (($(".active-permission").offset().top - $("div.permissions-main").offset().top) < 0)
		// // {
			// // $("div.permissions-main").scrollTop($("div.permissions-main").scrollTop() + $(".active-permission").offset().top - $("div.permissions-main").offset().top);
		// // }
		  // // scrolling magic
		  
		  
		// // var rowTop = $(".active-permission").offset().top;
		// // var rowBottom = rowTop + $(".active-permission").height();
		// // var $table = $("div.permissions-main"); // store instead of calling twice
		// // var tableHeight = $table.height();
		// // var currentScroll = $table.scrollTop();
		
		// // if (rowTop < 0)
		// // {
			// // // scroll up
			// // $("div.permissions-main").scrollTop(currentScroll + rowTop);
		// // }
		// // else if (rowBottom  > tableHeight)
		// // {
			// // // scroll down
			// // var scrollAmount = rowBottom - tableHeight;
			// // $("div.permissions-main").scrollTop(currentScroll + scrollAmount);
		// // }
		 
		 // // var listLength = $("div.permissions-main ul:not(.displayNone) .permissions-list-item").length;
			// // var index = $("div.permissions-main ul:not(.displayNone) .permissions-list-item").index($(".active-permission"));
			// // $("div.permissions-main").scrollTop($targetItem.position().top + $("div.permissions-main").scrollTop());
			// // if (index < listLength) {
				// // $("div.permissions-main").animate({
					// // scrollTop: $targetItem.position().top + $("div.permissions-main").scrollTop()
				// // }, 'slow');
			// // }
			// // // arrow up
			// // if (index > 0) {
				
			// // }
	
		 
		 
		// // scrollToActiveLi()
		// // $("div.permissions-main").scrollTop() + $(".active-permission")[0].clientHeight;
		// // e.preventDefault();
	// //	 e.stopPropagation();
	// }

	// function scrollToActiveLi()
	// {
		// // liHeight = $("li.permissions-list-item").height();
		// // $("div.permissions-main").scrollTop($('li.permissions-list-item').index($(".active-permission")) * $('.permissions-list-main li').height());
		
		// // var container = $("div.permissions-main"),
		// // scrollTo = $(".active-permission");

		// // container.scrollTop( scrollTo.offset().top - container.offset().top + container.scrollTop());
		// $("div.permissions-main").scrollTop($(".active-permission").position().top);
	// }
	 
	/*
    Find a html element's position.
    Adapted from Peter-Paul Koch of QuirksMode at   http://www.quirksmode.org/js/findpos.html
	*/
	// function findPos(obj)
	// {
		// //var curleft = 0;
		// var curtop = 0;
		// // var curxscroll = 0;
		// var curyscroll =0;

		// while(obj && obj.offsetParent)
		// {
			// curyscroll = obj.offsetParent.scrollTop || 0;
			// // curxscroll = obj.offsetParent.scrollLeft || 0;
			// // curleft += obj.offsetLeft - curxscroll;
			// curtop += obj.offsetTop - curyscroll;
			// obj = obj.offsetParent;
		// }

		// return curtop;
	// }
	
	
	// function _keyDownEvent(e){
		// $thisItem =$(e.currentTarget).parents('.permissions-main').find(".active-permission");
		// $thisItem.removeClass('active-permission');
		// $nextItem = $thisItem.nextAll('li:not(.permissions-list-header):first');
		
		// if($nextItem.length == 1)
		// {
			// $nextItem.addClass('active-permission');
		// }
		// else{
			// $thisItem.parent().children("li").not(".permissions-list-header").first().addClass('active-permission');
		// }
	// }
	
	// function _keyUpEvent(e){
		// $thisItem = $(e.currentTarget).parents('.permissions-main').find(".active-permission");
		// $thisItem.removeClass('active-permission');
		// $prevItem = $thisItem.prevAll('li:not(.permissions-list-header):first');
		
		// if($prevItem.length == 1)
		// {
			// $prevItem.addClass('active-permission');
		// }
		// else{
			// $thisItem.parent().children("li").not(".permissions-list-header").last().addClass('active-permission');
		// }
	// }
	
	// function _keyLeftEvent(e){
		// // $thisItem = $(".active-permission");
		// // $permissionItems.removeClass('active-permission');
		
		// if( $targetItem.hasClass('list_item_M')) {
			// if($targetItem.children("ul.permissions-list").children().length == 0){
				// var parentCod = $(e.currentTarget).parents('.permissions-main').prop('className').split(' ')[1];
				// getChilds($targetItem,parentCod);
				
				// $permissionItemsToEvent.off('click', activatePermission);
				// $permissionItemsToNavigate.off('keydown', navigateLiEvents);
				// $popupItems.off('click', activatePermissionItem);
				// $permisionRadioBtn.off('click',permisionRadioBtnClick);
				// $permisionRadioBtnParents.off('mouseup',unCheckedBrothers);
			
				// $permissionItemsToNavigate =  $('.permissions-list-item');
				// $permissionItemsToEvent =  $('.permissions-list-item');//.children().not('.list-radio-btn').parent();
				// $popupItems = $('.permissions-popup-list-item');
				// $permisionRadioBtn = $('.list-radio-btn.permission-item-cell input:radio');
				// $permisionRadioBtnParents = $('.list_item_M .list-radio-btn.permission-item-cell');
				// $permissionItems =  $('.permissions-list-item');
				
				// $permissionItemsToEvent.on('click', activatePermission);
				// $permissionItemsToNavigate.on('keydown', navigateLiEvents);
				// $popupItems.on('click', activatePermissionItem);
				// $permisionRadioBtn.on('click',permisionRadioBtnClick);
				// $permisionRadioBtnParents.on('mouseup',unCheckedBrothers);
			// }
		
			// $targetItem.removeClass('active-permission');
			// $targetItem.children("ul.permissions-list").children("li:first").addClass('active-permission');
			// //$targetItem.addClass('active-permission');
			// activateButtons(e);
			
			// // Adding rotate animation to category arrow
			// $targetItem.find('>> .list-item-title > i').addClass('opened-category');

			// // Showing subcategory items 
			// $targetItem.children("ul.permissions-list").removeClass('displayNone');
		// }
	
	// }
	
	// function _keyRightEvent(e){
		// if($targetItem.attr("data-level") != 1)
		// {
			// $targetItem.removeClass('active-permission');
			// $parentItem = $targetItem.parent();
			// $parentItem.parent().find('.list-item-title i').removeClass('opened-category');
			// $parentItem.parent().addClass('active-permission');
			// // Hiding subcategory items 
			// $parentItem.addClass('displayNone');
			// $targetItem.find("ul.permissions-list").addClass('displayNone');
		// }
	// }

	var initPermissions = function(uniqueCod, pathStr) {
		
		var parentWindow = $("." + uniqueCod);
		
		parentWindow.find(".block-title").text(get_message_string(1278));
		parentWindow.find(".read-only-title").text(get_message_string(134));
		parentWindow.find(".EDI-Permission").text(get_message_string(1613));
		parentWindow.find(".writing-title").text(get_message_string(1279));
		parentWindow.find(".required-field-title").text(get_message_string(1286));
		parentWindow.find('.cancelPermissionChanges').text(get_message_string(1213));
		parentWindow.find('.savePermissionChanges').text(get_message_string(1212));
		
		if (window.privRestriction) {
			parentWindow.find(".EDI-Permission").hide();
		}
		
		// Set the first list item as active item
		openPathInBegin(uniqueCod, pathStr);
		
		//activateButtons();

	//	$permissionItemsToNavigate =  $('.permissions-list-item');
		$permissionItemsToEvent =  $('.permissions-list-item .list-item-title');//.children().not('.list-radio-btn').parent();
		$popupItems = $('.permissions-popup-list-item');
		$permisionRadioBtn = $('.list-radio-btn.permission-item-cell input:radio');
		$permisionRadioBtnParents = $('.list_item_M .list-radio-btn.permission-item-cell');
		$permissionItems =  $('.permissions-list-item');
		
		$permissionItemsToEvent.on('click', activatePermission);
		//$permissionItemsToNavigate.on('keydown', navigateLiEvents);
		$popupItems.on('click', activatePermissionItem);
		$permisionRadioBtn.on('click',permisionRadioBtnClick);
		$permisionRadioBtnParents.on('mouseup',unCheckedBrothers);

		// Add active class to the row when focus on radio button
		 $('.outer').on('focus', function(e) {
			 $(e.currentTarget).parents(".permissions-main").find('.permissions-list-item').removeClass('active-permission');
			 $(e.target).closest('.permissions-list-item').addClass('active-permission');
		 });

		// Close Permissions Popup on click X and "Cancel" button
		$('.permissionPopupClose').on('click', function(e){
			$(e.currentTarget).parents(".permissions-main").find('.permissionsPopup').addClass('displayNone');
			$popupItems.removeClass('active-permission');
		});

		$('.cancelPermissionChanges').on('click', function(e){
			$(e.currentTarget).parents(".permissions-main").find('.permissionsPopup').addClass('displayNone');
			$popupItems.removeClass('active-permission');
		});

		$('.savePermissionChanges').on('click', function(e){
			var codID = $(e.currentTarget).parents('.permissions-main').prop('className').split(' ')[1];
			onColumnsOk(colLogicsArray[codID]);
			$(e.currentTarget).parents(".permissions-main").find('.permissionsPopup').addClass('displayNone');
			$popupItems.removeClass('active-permission');
		});
		
	};
	
	function openPathInBegin(uniqueCod, pathStr)
	{
		var dataIdArray = pathStr.replace("[", "").replace(" ]", "").replace("]", "").split(" ");
		var currentLi = $("." + uniqueCod).find('.permissions-list-main .permissions-list-item').first();
		if(dataIdArray.length == 1)
		{
			getChilds(currentLi,uniqueCod);
			// Adding rotate animation to category arrow
			currentLi.find('>> .list-item-title > i').addClass('opened-category');

			// Showing subcategory items 
			currentLi.children("ul.permissions-list").removeClass('displayNone');
		}
		else{
			var tempDataId = dataIdArray[0];
			for (tabsNum = 1; tabsNum <= dataIdArray.length - 1; tabsNum++) { 				

				getChilds(currentLi,uniqueCod);
				
				// Adding rotate animation to category arrow
				currentLi.find('>> .list-item-title > i').addClass('opened-category');

				// Showing subcategory items 
				currentLi.children("ul.permissions-list").removeClass('displayNone');
	
				tempDataId = tempDataId + "_" + dataIdArray[tabsNum];
				currentLi = $(".permissions-main." + uniqueCod).find("ul[data-id='" + tempDataId + "']").parent("li");
			}
		}
		
		// Set the first list item as active item
		$targetItem = currentLi;
		$targetItem.focus().addClass('active-permission');
		//paintActionButtons(uniqueCod)
		activateButtons();
	}
	
	function illegal_operation_callback(winID, messageID, prevPrivCode, prevNodePathStr)
	{
		var dataId = prevNodePathStr.replace("[", "").replace(" ]", "").replace("]", "").replace(/\ /g, "_");
		currentLi =  $(".permissions-main." + winID).find("ul[data-id='" + dataId + "']").parent("li");
		
		if (currentLi.length != 0) {
			 
			currentLi.find("> .list-radio-btn >> input:checked").each(function(){
				$(this).prop('checked', false);
			 });
			 
			 currentLi.find("> .list-radio-btn > .radio").removeClass("partly-checked");
			 currentLi.children("span:first").removeClass("circle-status-icon");
			
			if(prevPrivCode.toString().charAt(0) == '2')
			{
				currentLi.find("> .list-radio-btn >> .radio3").parent().addClass("partly-checked");
			}
			else if(prevPrivCode.toString().charAt(0) == '3')
			{
				currentLi.find("> .list-radio-btn >> .radio3").prop('checked', true);
			}
			
			if(prevPrivCode.toString().charAt(1) == '2')
			{
				currentLi.find("> .list-radio-btn >> .radio2").parent().addClass("partly-checked");
			}
			else if($numPriv.toString().charAt(1) == '3')
			{
				currentLi.find("> .list-radio-btn >> .radio2").prop('checked', true);
			}
			
			if($numPriv.toString().charAt(2) == '2')
			{
				currentLi.find("> .list-radio-btn >> .radio1").parent().addClass("partly-checked");
			}
			else if($numPriv.toString().charAt(2) == '3')
			{
				currentLi.find("> .list-radio-btn >> .radio1").prop('checked', true);
			}
			
			if($numPriv.toString().charAt(3) == '2')
			{
				 currentLi.children("span:first").addClass("circle-status-icon");
			}
		}
	}